import { combineReducers } from '@reduxjs/toolkit';
import user from './user/userSlice'

const createRootReducer = () => {
  return combineReducers({
    user
  });
};

export default createRootReducer;